import { render, staticRenderFns } from "./bv-subtitle-dialog.vue?vue&type=template&id=01660582&"
import script from "./bv-subtitle-dialog.vue?vue&type=script&lang=ts&"
export * from "./bv-subtitle-dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports